import { toLocalID } from 'src/shared/helpers';

export const salesChannelList = [
    {
        value: 'SHOPIFY',
        label: 'Shopify',
        titleDialog: 'Add Shopify as sales channel',
        zendeskDocId: '360024941034',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'WOO_COMMERCE',
        label: 'WooCommerce',
        titleDialog: 'Add WooCommerce as sales channel',
        zendeskDocId: '360024308714',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'PRESTA_SHOP',
        label: 'PrestaShop',
        titleDialog: 'Add PrestaShop as sales channel',
        zendeskDocId: '360025096873',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'BIG_COMMERCE',
        label: 'BigCommerce',
        titleDialog: 'Add BigCommerce as sales channel',
        zendeskDocId: '360026137574',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'MAGENTO',
        label: 'Magento / Adobe Commerce',
        titleDialog: 'Add Magento as sales channel',
        zendeskDocId: '360025157553',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'ETSY',
        label: 'Etsy',
        titleDialog: 'Add Etsy as sales channel',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        zendeskDocId: '360017498420',
        urlToRedirect: 'https://zakeke.zendesk.com/hc/en-us/articles/360017498420-Connect-Etsy-store'
    },
    {
        value: 'AMAZON',
        label: 'Amazon',
        titleDialog: 'Add Amazon as sales channel',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        zendeskDocId: '20025247198236',
        urlToRedirect: 'https://zakeke.zendesk.com/hc/en-us/articles/20025247198236-Connect-to-Amazon'
    },
    {
        value: 'OPEN_CART',
        label: 'OpenCart',
        titleDialog: 'Add OpenCart as sales channel',
        zendeskDocId: '360017787320',
        cantBeAddedAsAdditional: false,
        isDisabled: false,
        urlToRedirect: null
    },
    { value: 'API', label: 'API', titleDialog: 'Add API as sales channel', cantBeAddedAsAdditional: false, isDisabled: false, urlToRedirect: null },
    {
        value: 'COMMERCE_CLOUD',
        label: 'SalesForce Commerce Cloud',
        titleDialog: 'Add SalesForce Commerce Cloud as sales channel',
        zendeskDocId: '360003447099',
        cantBeAddedAsAdditional: true,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'WIX',
        label: 'Wix',
        titleDialog: 'Add Wix as sales channel',
        zendeskDocId: '5090942643740',
        cantBeAddedAsAdditional: true,
        isDisabled: false,
        urlToRedirect: null
    },
    {
        value: 'SHOP_WIRED',
        label: 'ShopWired',
        titleDialog: 'Add ShopWired as sales channel',
        zendeskDocId: '4419445156764',
        cantBeAddedAsAdditional: true,
        isDisabled: false,
        urlToRedirect: null
    }
] as const;

interface SCStoreNumber {
    readonly salesChannelID: string;
    readonly storeNumber: number;
}

const errorMessageList = [
    'URL is mandatory',
    "Insert a valid store URL with 'http://' or 'https://' protocol at the start",
    'Insert a valid domain for the store URL',
    'Insert a store URL without spaces',
    "Insert a valid products API URL with 'http://' or 'https://' protocol at the start",
    'Insert a valid domain for the products API URL',
    'Insert a products API URL without spaces'
];

export const checkUrl = (url: string, isStoreUrl: boolean = false, isProductApiUrl: boolean = false): string => {
    const protocolRegex = /^(http:\/\/|https:\/\/)/;
    const domainRegex = /^(http:\/\/|https:\/\/).+/;

    if (isStoreUrl && url === '') return errorMessageList[0];
    else if (isStoreUrl && !protocolRegex.test(url)) return errorMessageList[1];
    else if (isStoreUrl && !domainRegex.test(url)) return errorMessageList[2];
    else if (isStoreUrl && url.includes(' ')) return errorMessageList[3];
    else if (isProductApiUrl && url !== '' && !protocolRegex.test(url)) return errorMessageList[4];
    else if (isProductApiUrl && url !== '' && !domainRegex.test(url)) return errorMessageList[5];
    else if (isProductApiUrl && url !== '' && url.includes(' ')) return errorMessageList[6];
    else return '';
};

export const generateStoreNumbers = (salesChannelIDs: string[]) => {
    let storeNumber = 0;

    const scStoreNumbers: SCStoreNumber[] = [];

    salesChannelIDs
        .sort((a, b) => (toLocalID(a) || 1) - (toLocalID(b) || 1))
        .forEach((id) => {
            storeNumber++;
            scStoreNumbers.push({ salesChannelID: id, storeNumber: storeNumber });
        });

    return scStoreNumbers;
};

export const canSwitchSalesChannel = (secondarySalesChannelID: string, secondaryEcommerceName: string, masterEcommerceName: string) => {
    const unsupported = ['NONE', 'WIX', 'SHOP_WIRED', 'SHOPWARE', 'C_CLOUD'];
    const bothShopify = masterEcommerceName === 'SHOPIFY' && secondaryEcommerceName === 'SHOPIFY';
    const neitherShopify = masterEcommerceName !== 'SHOPIFY' && secondaryEcommerceName !== 'SHOPIFY';
    return (
        secondarySalesChannelID !== 'guid://Zakeke/SalesChannel/1' &&
        !unsupported.includes(secondaryEcommerceName) &&
        !unsupported.includes(masterEcommerceName) &&
        (bothShopify || neitherShopify)
    );
};
